<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="关注ID">
                  <GridSelectU title="选择任务" style="width: 200px;" labelName="taskName" labelValue="id" :value="queryForm.followId" :limit='1' size='small' placeholder='请选择任务' @getValue="getSeachValueFOLLOW" :columns="TASKFOLLOW_code" :searchs="TASKFOLLOW_search" dataListUrl="/mcn/follow/findList" entityBeanName="mcnTaskFollow" queryEntityUrl="/mcn/follow/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="进入房间的用户ID">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                               size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnTaskFollowRoomList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addMcnTaskFollowRoom"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editMcnTaskFollowRoom(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteMcnTaskFollowRoom(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMcnTaskFollowRoomList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMcnTaskFollowRoomList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mcnTaskFollowRoomList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="followId"
        label="关注ID"
      >
<!--          <template slot-scope='scope'>-->
<!--              <div v-if="scope.row.follow">-->
<!--                  {{ scope.row.follow.taskName }}-->
<!--              </div>-->
<!--              <div v-else>&#45;&#45;</div>-->
<!--          </template>-->
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="进入房间的用户ID"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                  <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                  <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                  <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="进入时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMcnTaskFollowRoom(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editMcnTaskFollowRoom(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteMcnTaskFollowRoom(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mcnTaskFollowRoomStates[mcnTaskFollowRoomState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mcnTaskFollowRoom"
          ref="mcnTaskFollowRoomForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="关注ID"
            prop="followId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mcnTaskFollowRoom.followId"-->
<!--              :disabled="mcnTaskFollowRoomState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 200px;" labelName="taskName" :disabled="mcnTaskFollowRoomState == 'check'"
                           labelValue="id" title="选择任务" :value="mcnTaskFollowRoom.followId" :limit='1' size='small' placeholder='请选择任务'
                           @getValue="getValueFOLLOW" :columns="TASKFOLLOW_code" :searchs="TASKFOLLOW_search" dataListUrl="/mcn/follow/findList" entityBeanName="mcnTaskFollow" queryEntityUrl="/mcn/follow/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="进入房间的用户ID"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mcnTaskFollowRoom.userId"-->
<!--              :disabled="mcnTaskFollowRoomState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFollowRoomState == 'check'"
                           labelValue="id" title="选择用户" :value="mcnTaskFollowRoom.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mcnTaskFollowRoomState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER,USER_SEARCH,TASKFOLLOW,TASKFOLLOW_SEARCH } from '@/utils/constant.js';
export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMcnTaskFollowRoomList();
                    this.getMcnTaskFollowRoomList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMcnTaskFollowRoomList();
                    this.getMcnTaskFollowRoomList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     followId: '', //关注ID
                     userId: '', //进入房间的用户ID
                },
                TASKFOLLOW_code: TASKFOLLOW,
                TASKFOLLOW_search: TASKFOLLOW_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mcnTaskFollowRoomState: 'add',
                mcnTaskFollowRoomStates: {
                    add: '新建mcn_task_follow_room',
                    check: '查看房间用户',
                    edit: '修改mcn_task_follow_room'
                },

                multipleSelection: [],
                mcnTaskFollowRoomList: [],
                mcnTaskFollowRoom: {
                    id: '', //ID
                    followId: '', //关注ID
                    userId: '', //进入房间的用户ID
                },
                btnLoading: false,

                rules: {
                    followId: [{ required: true, message: '关注ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '进入房间的用户ID不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMcnTaskFollowRoomList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 搜索用户
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            getSeachValueFOLLOW(value){
                this.queryForm.followId = value
            },
            getValueUser(value) {
                this.mcnTaskFollowRecord.userId = value
            },
            getValueFOLLOW(value) {
                this.mcnTaskFollowRecord.followId = value
            },
            resetMcnTaskFollowRoomList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mcnTaskFollowRoomList = [];
            },
            resetDialog() {
                this.mcnTaskFollowRoomState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      followId: '', //关注ID
                      userId: '', //进入房间的用户ID
                };
                this.getMcnTaskFollowRoomList();
            },
            closeDialog() {
                this.showDialog = false
                this.mcnTaskFollowRoom = {
                      id: '', //ID
                      followId: '', //关注ID
                      userId: '', //进入房间的用户ID
                };
            },
            submitForm() {
                if (this.mcnTaskFollowRoomState == 'add') {
                    this.$refs.mcnTaskFollowRoomForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/taskfollowroom/add`,{ ...this.mcnTaskFollowRoom }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMcnTaskFollowRoomList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mcnTaskFollowRoomState == 'edit') {
                    this.$refs.mcnTaskFollowRoomForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/taskfollowroom/edit`,{ ...this.mcnTaskFollowRoom }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMcnTaskFollowRoomList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMcnTaskFollowRoom() {
                this.showDialog = true;
                this.mcnTaskFollowRoomState = 'add';
            },
            checkMcnTaskFollowRoom(mcnTaskFollowRoomId) {
                console.log(mcnTaskFollowRoomId);
                this.currentMcnTaskFollowRoomId = mcnTaskFollowRoomId;

                this.getMcnTaskFollowRoomById();
                this.showDialog = true;
                this.mcnTaskFollowRoomState = 'check';
            },
            editMcnTaskFollowRoom(mcnTaskFollowRoomId) {
                console.log('mcnTaskFollowRoom', mcnTaskFollowRoomId);
                if (mcnTaskFollowRoomId) {
                    this.currentMcnTaskFollowRoomId = mcnTaskFollowRoomId;
                    this.getMcnTaskFollowRoomById();
                } else {
                    this.mcnTaskFollowRoom = { ...this.mcnTaskFollowRoom, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mcnTaskFollowRoomState = 'edit';
            },
            deleteMcnTaskFollowRoom(mcnTaskFollowRoomId) {
                let ids = '';
                if (mcnTaskFollowRoomId) {
                    ids = mcnTaskFollowRoomId;
                } else {
                    ids = this.multipleSelection.map((mcnTaskFollowRoom) => mcnTaskFollowRoom.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mcn/taskfollowroom/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFollowRoomList();
                                this.getMcnTaskFollowRoomList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMcnTaskFollowRoomList() {
                this.resetMcnTaskFollowRoomList();
                this.getMcnTaskFollowRoomList();
            },
            getMcnTaskFollowRoomList(query = {}) {
                this.loading = true;
                get(`/mcn/taskfollowroom/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mcnTaskFollowRoomList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMcnTaskFollowRoomById() {
                get(`/mcn/taskfollowroom/get`,{ id: this.currentMcnTaskFollowRoomId }).then((res) =>{
                    if(res.success){
                      this.mcnTaskFollowRoom = { ...this.mcnTaskFollowRoom, ...res.mcnTaskFollowRoom };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMcnTaskFollowRoomList() {
                //this.btnLoading = true;
                exprotExcel(`/mcn/taskfollowroom/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mcn/taskfollowroom/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mcn/taskfollowroom/importData`,formData);
              this.refreshMcnTaskFollowRoomList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMcnTaskFollowRoomList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMcnTaskFollowRoomList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>